import { ROOT_URL } from 'gatsby-env-variables'
import { useContext, useEffect, useState } from 'react'
import { navigate } from 'gatsby'
import classNames from 'classnames'
import If from '@mobi/components/If'
import ImgStoryblok from 'components/ImgStoryblok'
import Text from 'components/Text'
import { useContent } from 'modules/Content'
import { ThemeContext } from 'modules/Theme'
import backToHomeRedirect from 'utils/backToHomeRedirect'
import analytics from '@mobi/libraries/analytics'
import './Header.scss'
import ItauBusinessBanner from 'components/ItauBusinessBanner'

const logoItauImg =
  'https://assets.renegocie.gruporecovery.com/f/119473/x/bdd2ba345d/itau-icon.svg'

const Header = () => {
  const { header_logo } = useContent('config')
  const { theme } = useContext(ThemeContext)

  const [headerLogo, setHeaderLogo] = useState()

  const isRecoveryOrigin = theme === 'recovery'
  const isItauOrigin = theme === 'itaucard'
  const toUrl = isItauOrigin ? null : backToHomeRedirect()

  useEffect(() => {
    setHeaderLogo(header_logo)
  }, [])

  const handleLogoTracking = (ev) => {
    const element = ev?.currentTarget

    analytics.track('elementClicked', {
      location: element.dataset.trackingLocation,
      position: element.dataset.trackingPosition,
      elementType: element.dataset.trackingElement,
      text: element.ariaLabel,
      htmlId: element.dataset.unique,
      actionOutcome: element.dataset.trackingActionoutcome,
      outboundUrl: element.dataset.trackingOutboundurl,
    })
  }

  const recoveryLogo =
    'https://a.storyblok.com/f/119473/x/ccbfa1f547/logo-recovery.svg'

  return (
    <>
      <header
        className={classNames(`header ${theme}`, {
          variant:
            headerLogo?.[0].label === 'Logo Recovery' || isRecoveryOrigin,
        })}
      >
        <div
          className={classNames('logo', {
            'logo-generalTheme': theme !== 'recovery',
          })}
          data-unique="da59bad1-4dfa-4556-a5da-fe7b3919fe0d"
          id="logo-header"
          role="button"
          data-tracking-location="header"
          data-tracking-position="header-menu"
          data-tracking-actionoutcome="redirect"
          data-tracking-element="link"
          aria-label={headerLogo?.[0].label}
          data-tracking-outboundurl={ROOT_URL}
          onClick={(ev) => {
            navigate(toUrl)
            handleLogoTracking(ev)
          }}
        >
          <If
            condition={isItauOrigin}
            renderIf={
              <div className="header-itau-theme-logo">
                <img src={logoItauImg} alt="Logo Itaú" width={48} height={48} />
              </div>
            }
            renderElse={
              <If
                condition={isRecoveryOrigin}
                renderIf={
                  <ImgStoryblok
                    src={recoveryLogo}
                    width={100}
                    height={18}
                    alt="Logo Recovery"
                  />
                }
                renderElse={
                  <ImgStoryblok
                    src={headerLogo?.[0]?.image?.filename || recoveryLogo}
                    alt={headerLogo?.[0].label || 'Logo'}
                  />
                }
              />
            }
          />
        </div>
        <If
          condition={isRecoveryOrigin}
          renderIf={
            <div className="header__container-itau">
              <div
                className="banner-itau"
                aria-label="Uma empresa Itaú"
                role="img"
              >
                <Text p aria-hidden="true" size={5}>
                  Uma empresa
                </Text>
                <ImgStoryblok
                  src="https://a.storyblok.com/f/119473/x/5d3952a243/itauicon_footer.svg"
                  width={25}
                  height={32}
                  alt="logo Itaú"
                  aria-hidden="true"
                />
              </div>
            </div>
          }
        />
      </header>
      <If condition={isItauOrigin} renderIf={<ItauBusinessBanner />} />
    </>
  )
}

export default Header
